import {forEach, some} from 'lodash';
import ProfilesService from 'top20common/distribution/services/profiles';

export default {
  saveTrainingAction(context, data) {
    context.commit('mutateEditProfileLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.saveTrainingsAction(data)
        .then(response => {
          context.commit('mutateEditProfileLoadingState', false);
          context.commit('mutateProfileCompletenessState', response.data.meta);
          context.commit('setTrainingsListState', response.data.result);
          resolve(response.data.result);
        })
        .catch(error => {
          let errors = [];
          forEach(error.response.data.errors, value => {
            errors.push(value[0]);
          });
          context.commit('mutateEditProfileLoadingState', false);
          reject(errors);
        });
    });
  },
  cleanTrainingsListAction(context) {
    let list = [...context.getters.trainingsListState];
    for (let i = list.length - 1; i >= 0; i--) {
      if (!some(Object.values(list[i]))) {
        context.commit('deleteTrainingItem', i);
      }
    }
  }
};
